<template>
  <div class="asset _flxccc">
    <div class="asset__load _flxcs">
      <div class="asset__load__filter">
        <input placeholder="Filter assets" type="text" name="assetFilter" v-model="textFilter" />
      </div>
      <div class="asset__container">
        <list :items="filteredAssets" v-on:openMetaForm="onOpenMetaForm" v-on:add="onToggleAddForm"></list>
      </div>
    </div>
    <!-- new asset form in modal -->
    <modal v-if="showAdd" hasClose="true" v-on:close="onCloseAddForm">
      <section slot="header">
        <span class="txt-bold">NEW VIDEO ASSET</span>
      </section>
      <section slot="body" class="asset__meta">
        <add v-on:close="onCloseAddForm"></add>
      </section>
    </modal>
    <!-- update asset form in modal -->
    <modal v-else-if="showMeta" hasClose="true" v-on:close="onCloseMetaForm">
      <section slot="header">
        <span class="txt-bold">UPDATE VIDEO ASSET</span>
      </section>
      <section slot="body" class="asset__meta">
        <edit
          v-on:close="onCloseMetaForm"
          v-if="selectedAsset.visible && selectedProject.id === selectedAsset.projectId && !showAdd"
          :item="selectedAsset"
        ></edit>
      </section>
    </modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import List from "./list";
import Add from "./add";
import Edit from "./edit";
import modal from "./../core/Modal";

export default {
  name: "asset",
  components: { List, Add, Edit, modal },
  computed: {
    ...mapGetters(["video", "assets", "selectedAsset", "selectedProject"]),
    filteredAssets() {
      const assets = this.assets;
      return assets.filter(asset => {
        return (
          (asset.title || asset.videoTitle || "")
            .toLowerCase()
            .indexOf((this.textFilter || "").toLowerCase()) >= 0
        );
      });
    }
  },
  created() {
    this.loadAssets();
  },
  data: () => ({
    showAdd: false,
    textFilter: null,
    showMeta: false
  }),
  methods: {
    ...mapActions(["saveAsset", "loadData", "loadAssets"]),
    onOpenMetaForm(item) {
      this.showAdd = false;
      this.showMeta = true;
    },
    onToggleAddForm() {
      this.showAdd = !this.showAdd;
    },
    onCloseAddForm() {
      this.showAdd = false;
    },
    onCloseMetaForm() {
      this.showMeta = false;
    }
  }
};
</script>
